import ApiService from "@/core/services/ApiService";
import {
  LuxConfig,
  LuxContextType,
  LuxConversation,
  LuxMessage,
  LuxUsage,
} from "@/modern/types/lux";

const unwrapData = (response: any) => response?.data?.data ?? response?.data ?? {};

export const luxService = {
  async fetchConfig(): Promise<LuxConfig> {
    const response = await ApiService.get("/lux/config");
    return unwrapData(response) as LuxConfig;
  },

  async listConversations(): Promise<LuxConversation[]> {
    const response = await ApiService.get("/lux/conversations");
    // Endpoint paginado: os itens vêm em data[].
    return (response?.data?.data ?? []) as LuxConversation[];
  },

  async createConversation(params: {
    context_type?: LuxContextType;
    context_id?: number | null;
    language?: string;
  }): Promise<LuxConversation> {
    const response = await ApiService.post("/lux/conversations", params as any);
    return unwrapData(response) as LuxConversation;
  },

  async fetchConversation(uuid: string): Promise<LuxConversation> {
    const response = await ApiService.get(`/lux/conversations/${uuid}`);
    return unwrapData(response) as LuxConversation;
  },

  async deleteConversation(uuid: string): Promise<void> {
    await ApiService.delete(`/lux/conversations/${uuid}`);
  },

  async sendMessage(
    uuid: string,
    content: string,
    language: string
  ): Promise<{ message: LuxMessage; usage: LuxUsage }> {
    const response = await ApiService.post(`/lux/conversations/${uuid}/messages`, {
      content,
      language,
    } as any);

    return {
      message: unwrapData(response) as LuxMessage,
      usage: response?.data?.usage as LuxUsage,
    };
  },
};
